import { Badge } from '@zoopla-eng/zds-components/badges';
import { Grid } from '@zoopla-eng/zds-components/grid';
import { ListingImage } from '@zoopla/listings/image';
import { ListingFeatureList } from '@zoopla/listings/features';
import {
    ListingCardMini,
    ListingCardMiniSkeleton
} from '@zoopla/listings/cards';
import { getBadgeForSavedListing } from '@zoopla/listing-badges';
import {
    badgeStyle,
    saveListingsCardMiniGrid,
    styledListingCardMiniDetailsStyle,
    styledListingCardMiniPriceStyle,
    styledListingCardMiniTitleStyle
} from './SavedListingsWidgetMobile.styles.css';
import { trackClickSavedListingWidgetCard } from '../SavedListingsWidget.tracking';
import { useListing } from '../graphql/Listing/useListing';

export const SavedListingCardMobile = ({
    listingId,
    isTriggered
}: {
    listingId: string;
    isTriggered: boolean;
}) => {
    const listing = useListing(listingId, !isTriggered);

    if (!listing) {
        return <ListingCardMiniSkeleton />;
    }

    const {
        imagePreview,
        featurePreview,
        displayAddress,
        listingLinkHref,
        displayPrice,
        shortDisplayAddress,
        publicationStatus,
        section,
        statusSummary,
        tags
    } = listing;

    const badgeProps = getBadgeForSavedListing({
        isExpired: publicationStatus === 'Expired',
        isNewHomes: section === 'new-homes',
        statusSummaryLabel: statusSummary?.label,
        tagLabels: tags?.map(({ label }) => label)
    });

    return (
        <ListingCardMini
            testId="saved-listing-card-mobile"
            listingLinkHref={listingLinkHref}
            trackClick={trackClickSavedListingWidgetCard}
        >
            <Grid className={saveListingsCardMiniGrid}>
                <Grid.Item area="image">
                    <ListingImage
                        image={imagePreview}
                        useImageLazyLoad={true}
                    />
                </Grid.Item>
                <Grid.Item area="content">
                    <div
                        className={styledListingCardMiniDetailsStyle}
                        data-name="details"
                        data-testid={`mini-saved-property-card-details-${listingId}`}
                    >
                        <div
                            className={styledListingCardMiniTitleStyle}
                            data-name="title"
                        >
                            {shortDisplayAddress || displayAddress}
                        </div>
                        <div
                            className={styledListingCardMiniPriceStyle}
                            data-name="price"
                        >
                            {displayPrice}
                        </div>
                        <ListingFeatureList features={featurePreview} />
                    </div>
                </Grid.Item>
            </Grid>

            {badgeProps ? (
                <div className={badgeStyle} data-name="badge-mini">
                    <Badge {...badgeProps} />
                </div>
            ) : null}
        </ListingCardMini>
    );
};
